import { AdditionalQuestionsModel } from "./additionalQuestions/additionalQuestions";
import { BusinessActivityId } from "./additionalQuestions/businessActivity";

export class RequestMapper {
  public static mapPartOfFarm(estate: any, additionalQuestions: AdditionalQuestionsModel) {
    Object.assign(estate, {
      partOfFarm: additionalQuestions.partOfFarm.value || false
    });
  }

  public static mapBusinessActivity(estate: any, additionalQuestions: AdditionalQuestionsModel) {
    Object.assign(estate, {
      businessActivity: additionalQuestions.businessActivityInBuilding.value || BusinessActivityId.no
    });
  }

  public static mapBusinessActivityType(estate: any, additionalQuestions: AdditionalQuestionsModel) {
    if (additionalQuestions.businessActivityInBuilding.value === BusinessActivityId.under50percent) {
      Object.assign(estate, {
        businessActivityType: additionalQuestions.typeOfActivity
      });
    }
  }
}
